// extracted by mini-css-extract-plugin
module.exports = {"searchWrapper":"index-module_searchWrapper_pazCH","hotword":"index-module_hotword_2MRnH"};